// extracted by mini-css-extract-plugin
export default {"element":"UploadLoader_element__8RAbg","anima":"UploadLoader_anima__ewloj","circle":"UploadLoader_circle__kpFnw","scale":"UploadLoader_scale__m03eI"};